export default "__VITE_ASSET__abfb41db__"